import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import config from 'config';
import MainContent from 'components/MainContent';

import { Link as LinkRouter } from 'react-router-dom';
import { Button, Flexer, Spacer } from '@ontruck/orc';

import { useGetLatestVersion } from 'modules/versioning';

import { getClientConfig, constants } from 'redux/modules/client-config/selectors';
import { useSelector } from 'react-redux';

const t = {
  release: 'Release',
  title: 'Settings',
  logout: 'Log out from TMS',
  clear_cache: 'Clear cache',
  users: 'Manage users',
  postal_codes: 'Manage postal codes',
  driver_positions: 'Driver positions',
  user_preferences: 'User preferences',
  shipper_contracts: 'Shipper contracts',
};

const StyledArticle = styled.article`
  margin-left: 7rem;
  max-width: 1440px;
`;
export const SettingsContainer = ({ user }) => {
  const usersButton = `${config.BASE_ROUTE}user`;
  const postalCodesButton = `${config.BASE_ROUTE}postal-codes`;
  const driverPositionsButton = `${config.BASE_ROUTE}driver-positions`;
  const preferencesButton = `${config.BASE_ROUTE}preferences`;
  const shipperContractsButton = `${config.AIRTABLE_CONTRACTS_URL}`;

  const latestVersion = useGetLatestVersion();

  const BUTTONS = useSelector((store) => getClientConfig(store, constants.TABS));

  return (
    <MainContent>
      <StyledArticle>
        <h1>{t.title}</h1>
        <Flexer.Parent>
          {BUTTONS[constants.POSTAL_CODES_SECTION] && (
            <Flexer.Child mRight="S">
              <Button as={LinkRouter} to={postalCodesButton} ghost>
                {t.postal_codes}
              </Button>
            </Flexer.Child>
          )}
          {BUTTONS[constants.USERS_SECTION] && (
            <Flexer.Child mRight="S">
              <Button as={LinkRouter} to={usersButton} ghost>
                {t.users}
              </Button>
            </Flexer.Child>
          )}
          {BUTTONS[constants.DRIVER_POSITION_SECTION] && (
            <Flexer.Child mRight="S">
              <Button as={LinkRouter} to={driverPositionsButton} ghost>
                {t.driver_positions}
              </Button>
            </Flexer.Child>
          )}
          {BUTTONS[constants.PREFERENCES_SECTION] && (
            <Flexer.Child mRight="S">
              <Button as={LinkRouter} to={preferencesButton} ghost>
                {t.user_preferences}
              </Button>
            </Flexer.Child>
          )}
          {BUTTONS[constants.SHIPPERS_CONTRACTS_SECTION] && (
            <Flexer.Child mRight="S">
              <Button href={shipperContractsButton} ghost>
                {t.shipper_contracts}
              </Button>
            </Flexer.Child>
          )}
        </Flexer.Parent>

        <Spacer mTop="M">
          {t.release} {config.APP_VERSION} {!!latestVersion && <>(Latest: {latestVersion})</>}
        </Spacer>
      </StyledArticle>
    </MainContent>
  );
};

SettingsContainer.propTypes = {
  push: PropTypes.func,
  logout: PropTypes.func,
  user: PropTypes.object,
};

export const Settings = SettingsContainer;
